export default __webpack_public_path__ + "static/media/silverbackai.90ccd761.jpg";